import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PFS404Page from '../PFS404Page/PFS404Page';
import PFSAcquisitionsIndex from '../PFSAcquisitionsIndex/PFSAcquisitionsIndex';
import PFSYorke from '../PFSYorke/PFSYorke';
import PFSMedlock from '../PFSMedlock/PFSMedlock';
import PFSHuang from '../PFSHuang/PFSHuang';

const PFSAcquisitionRoutes = () => (
  <Routes>
    <Route path='/' element={<PFSAcquisitionsIndex />} />
    <Route path='/yorke' element={<PFSYorke />} />
    <Route path='/medlock' element={<PFSMedlock />} />
    <Route path='/huang' element={<PFSHuang />} />
    <Route path='*' element={<PFS404Page />} />
  </Routes>
);

PFSAcquisitionRoutes.propTypes = {};

export default PFSAcquisitionRoutes;
